import { TransformFullNameSchema } from 'components/shared/types/FullNameSchema';

export const createFullName = (fullName: TransformFullNameSchema) => {
  return `${fullName.lastName ?? ''} ${fullName.firstName} ${fullName.patronymic ?? ''}`.trim();
};

export const createLastAndFirstName = ({ lastName, firstName }: TransformFullNameSchema): string =>
  [lastName, firstName].filter(Boolean).join(' ');

export const createFullNameShort = ({
  lastName,
  firstName,
  patronymic,
}: {
  lastName?: string | null;
  firstName: string;
  patronymic?: string | null;
}) => {
  const patronymicShort = patronymic ? `${patronymic[0]}.` : '';
  const firstNameShort = `${firstName[0]}.`;

  if (!lastName) {
    return `${firstName} ${patronymicShort}`.trim();
  }

  return `${lastName} ${firstNameShort} ${patronymicShort}`.trim();
};
